import { render, staticRenderFns } from "./NewMessageBadgeIcon.vue?vue&type=template&id=5ce39de8"
import script from "./NewMessageBadgeIcon.vue?vue&type=script&lang=js"
export * from "./NewMessageBadgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports